import { intersects, mapIdsFromRelation } from './helpers'

const authChallenge = (challenge) => {
	// make sure challenge is parsed in right format
	return challenge?.attributes == undefined
		? challenge
		: {
				...challenge,
				...challenge?.attributes,
				id: challenge?.id,
		  }
}

export const hasRights: any = (auth) => {
	const authUser = auth.user
	const checks = {
		// organisations
		canEditOrganisation: function (_organisation) {
			if (auth.isAdmin()) {
				return true
			}
			// for now only super admin can edit
			// let userOrganisationIds = mapIdsFromRelation(auth, 'organisations')
			// if (
			// 	auth.hasRole(['organisation-admin']) &&
			// 	userOrganisationIds.includes(organisation.id)
			// ) {
			// 	return true
			// }
			return false
		},

		// users
		canEditUser: function (user) {
			let userOrganisationIds = mapIdsFromRelation(user, 'organisations')

			if (auth.isAdmin()) {
				return true
			}
			if (user.id == authUser.id) {
				return true
			}
			if (
				auth.hasRole(['organisation-admin']) &&
				userOrganisationIds.includes(authUser.organisation_id)
			) {
				if (['admin', 'organisation-admin'].includes(user.role)) {
					// not allow to edit higher user inside organisation
					return false
				}
				return true
			}
			return false
		},

		canDeleteUser: function (user) {
			if (user.id == authUser.id) {
				return false
			}
			return checks.canEditUser(user)
		},

		// challenges
		canEditChallenge: function (checkChallenge) {
			const challenge = authChallenge(checkChallenge)
			if (auth.isAdmin()) {
				return true
			}
			if (
				auth.hasRole(['organisation-admin']) &&
				authUser.organisation_ids.includes(challenge.organisationId)
			) {
				return true
			}
			if (
				auth.hasRole(['space-admin']) &&
				authUser.challenge_space_ids.includes(challenge.challengeSpaceId)
			) {
				return true
			}
			let challengeUsersIds = mapIdsFromRelation(challenge, 'challengeUsers')
			if (
				auth.hasRole(['company-owner']) &&
				challengeUsersIds.includes(authUser.id)
			) {
				return true
			}
			return false
		},

		canDeleteChallenge: function (checkChallenge) {
			const challenge = authChallenge(checkChallenge)
			if (auth.isAdmin()) {
				return true
			}
			if (
				auth.hasRole(['organisation-admin', 'space-admin']) &&
				authUser.organisation_ids.includes(challenge.organisationId)
			) {
				return true
			}
			if (
				auth.hasRole(['space-admin']) &&
				authUser.challenge_space_ids.includes(challenge.challengeSpaceId)
			) {
				return true
			}
			let challengeUsersIds = mapIdsFromRelation(challenge, 'challengeUsers')
			if (
				auth.hasRole(['company-owner']) &&
				challengeUsersIds.includes(authUser.id)
			) {
				// yes is own challenge, but only allow deletion of open-challenges
				if (challenge.attributes.openChallengeType != 'private') {
					return true
				}
			}

			return false
		},

		// challenges notes
		canManageChallengeNotes: function (checkChallenge) {
			const challenge = authChallenge(checkChallenge)
			if (auth.isAdmin()) {
				return true
			}
			if (
				auth.hasRole(['organisation-admin']) &&
				authUser.organisation_ids.includes(challenge.organisationId)
			) {
				return true
			}
			if (
				auth.hasRole(['space-admin']) &&
				authUser.challenge_space_ids.includes(challenge.challengeSpaceId)
			) {
				return true
			}
			// challenge owners & students are not allowed to see or edit notes
			return false
		},

		// space
		canManageSpace(space) {
			// Allow if admin
			// Allow if space admin on the space of this challenge
			// Allow if org admin belongs to same org of spaceId
			if (auth.isAdmin()) {
				return true
			}

			if (
				auth.hasRole(['organisation-admin']) &&
				authUser.organisation_ids.includes(
					space?.relationships?.organisation?.data?.id
				)
			) {
				return true
			}
			if (
				auth.hasRole(['space-admin']) &&
				authUser.challenge_space_ids.includes(space.id)
			) {
				return true
			}
			return false
		},

		// teams
		canEditTeam(team) {
			if (auth.isAdmin()) {
				return true
			}
			if (
				auth.hasRole(['organisation-admin']) &&
				authUser.organisation_ids.includes(team.organisationId)
			) {
				return true
			}

			if (auth.hasRole(['space-admin'])) {
				const teamChallengeSpaceIds = mapIdsFromRelation(
					team,
					'challengeSpaces'
				)

				if (intersects(authUser.challenge_space_ids, teamChallengeSpaceIds)) {
					return true
				}
			}

			if (auth.hasRole(['student'])) {
				return (
					authUser.relationships.teams.data.filter((t) => t.id === team.id)
						.length > 0
				)
			}

			return false
		},

		canEditLockedTeam(team) {
			if (auth.hasRole(['student'])) {
				return false
			}

			return checks.canEditTeam(team)
		},

		// companies
		canManageCompany(company) {
			if (auth.isAdmin()) {
				return true
			}
			if (auth.hasRole(['organisation-admin', 'space-admin'])) {
				// Org-admin / space-admin access depends on organisation/space
				// membership on the company's owner(s), which isn't available
				// client-side - let them through and the API enforces the real
				// rule (isUserAllowedToViewCompany), 403ing if not authorized.
				return true
			}
			if (
				auth.hasRole(['company-owner']) &&
				authUser.company_ids?.includes(company?.id)
			) {
				return true
			}
			return false
		},
	}
	return { ...auth, ...checks }
}
